import { useCallback, useEffect, useRef, useState } from 'react';

export function useMapReadiness({ fullGeoJson, onMapReady, onZctaReady, searchKey = 0 }) {
  const [mapReady, setMapReady] = useState(false);
  const hasReportedZctaReady = useRef(false);

  const handleMapReady = useCallback(() => {
    setMapReady(true);
    onMapReady?.();
  }, [onMapReady]);

  // Reset the guard on every new search (searchKey) or when fullGeoJson changes.
  // searchKey handles same-address re-searches where fullGeoJson is unchanged.
  // Must be declared before the reporting effect so React runs it first in the same render.
  useEffect(() => {
    hasReportedZctaReady.current = false;
  }, [fullGeoJson, searchKey]);

  useEffect(() => {
    if (!mapReady || typeof onZctaReady !== 'function' || hasReportedZctaReady.current) return;
    const hasGeoJson = fullGeoJson?.features?.length > 0;
    if (hasGeoJson) {
      hasReportedZctaReady.current = true;
      onZctaReady();
    }
  // searchKey must be here so this effect re-runs after the reset effect clears
  // hasReportedZctaReady — otherwise the flag is cleared but nothing fires onZctaReady.
  }, [mapReady, fullGeoJson, onZctaReady, searchKey]);

  return {
    mapReady,
    handleMapReady,
  };
}
